import { defineComponent as _defineComponent } from 'vue'
import { computed } from 'vue'
import { Trip } from '../models/dto'
import CUItineraryV2 from '@/components/CUItineraryV2.vue'
import CUItineraryItemV2 from '@/components/CUItineraryItemV2.vue'
import TripItineraryV2Timing from '@/components/TripItineraryV2Timing.vue'
import TripItineraryV2Icon from '@/components/TripItineraryV2Icon.vue'
import TripItineraryV2Details from '@/components/TripItineraryV2Details.vue'
import { TripItineraryV2Stop } from '@/models/ItineraryStop'
import { ItineraryStopTypeKey } from '@/utils/enum'


export default /*#__PURE__*/_defineComponent({
  __name: 'TripItineraryV2',
  props: {
    itineraryStops: null
  },
  setup(__props: any) {

const props = __props as {
  itineraryStops: TripItineraryV2Stop[]
};



return { __sfc: true,props, CUItineraryV2, CUItineraryItemV2, TripItineraryV2Timing, TripItineraryV2Icon, TripItineraryV2Details }
}

})